<template>
  <span
    ><v-icon color="red" size="small" class="ml-2">$iconArrowDown</v-icon></span
  >
</template>
<script>
export default {
  name: "UnqualifiedBadge"
};
</script>
